import * as ApiManager from './_manager';
import store from '../store';

export const subscription = {
  create: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/create`,
      payload
    );
  },
  cancel: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}/cancel`,
      payload
    );
  },
  resume: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}/resume`,
      payload
    );
  },
  get: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}`,
      payload
    );
  },
  getInvoices: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}/invoices`,
      payload
    );
  },
  downloadInvoice: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}/invoices/${payload.invoice_id}`,
      payload
    );
  },
  updatePaymentMethod: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}/paymentMethod/update`,
      payload
    );
  },
  switchToFullSubscription: payload => {
    return ApiManager.callApi (
        `/member/company/${store.getters['company/getSelected']}/subscription/${payload.subscription_id}/switchToFullSubscription`,
        payload
    );
  },
};
